(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("VueAMap", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["VueAMap"] = factory(require("vue"));
	else
		root["VueAMap"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_49__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition